// extracted by mini-css-extract-plugin
module.exports = {"loadingBox":"LoadingBox_loadingBox__FNMS8","loading":"LoadingBox_loading__fTYef","spinner":"LoadingBox_spinner__2N4b3"};